import { getBans, getPlayablePicks } from "model/Match/TrackPick";
import { CenterFlexColumn } from "styles/layout";
import { getNumTeams, MatchTeams } from "model/Match/MatchTeams";
import { RoundsBasedBan } from "./RoundsBasedBan";
import { RoundsBasedTrackStats } from "./RoundsBasedTrackStats";
import { NonTAMatchSet } from "model/Match/Set/MatchSet";
import { NonTAMatchTrack } from "model/Match/Track/MatchTrack";
import { RoundsBasedCompactTrackStats } from "./RoundsBasedCompactTrackStats";

interface Props {
  set: NonTAMatchSet;
  teams: MatchTeams;
  tournamentId: string;
}

export const RoundsBasedTracks = ({ set, teams, tournamentId }: Props) => {
  const playablePicks = getPlayablePicks(set);
  const bans = getBans(set.picks);
  const allPicksRandom = set.picks.every((p) => !p.rosterId);

  return (
    <CenterFlexColumn>
      {playablePicks.map((pick) => {
        const matchTracks = (set.tracks as NonTAMatchTrack[]).filter(
          (t) => t.trackId === pick.trackId
        );

        return getNumTeams(teams) > 10 ? (
          <RoundsBasedCompactTrackStats
            trackId={pick.trackId}
            matchTracks={matchTracks}
            teams={teams}
            pickingRosterId={pick.rosterId}
            tournamentId={tournamentId}
            showPickName={!allPicksRandom}
          />
        ) : (
          <RoundsBasedTrackStats
            trackId={pick.trackId}
            matchTracks={matchTracks}
            teams={teams}
            pickingRosterId={pick.rosterId}
            tournamentId={tournamentId}
            showPickName={!allPicksRandom}
          />
        );
      })}
      {bans.map((ban) => (
        <RoundsBasedBan
          trackId={ban.trackId}
          rosterId={ban.rosterId}
          tournamentId={tournamentId}
        />
      ))}
    </CenterFlexColumn>
  );
};
